// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

import CreateProject from './CreateProject';
import type { CreateProjectProps } from './CreateProject';

const messages = {
    title: (
        <FormattedMessage
            id="dc.ProjectForms.CreateProjectModal.title"
            defaultMessage="Create New Project"
        />
    ),
};

type CreateProjectModalProps = {|
    ...CreateProjectProps,
    isOpen?: boolean,
    onClose: () => void,
|};

export function CreateProjectModal(props: CreateProjectModalProps) {
    const { isOpen, onClose, ...createProjectProps } = props;

    return (
        <ModalContainer isOpen={!!isOpen} modalPosition="center" onClose={onClose}>
            <BarHeader title={messages.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <CreateProject {...createProjectProps} />
            </ModalBody>
        </ModalContainer>
    );
}

export default CreateProjectModal;
